import DOMPurify from 'dompurify'
import { parseHtml, addQueryParams, getCustomer } from 'helpers/utils'

const DisplayExternalHTML = (props) => {
  // Configures all links to open in new window
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    // set all elements owning target to target=_blank
    if ('target' in node && node.hasOwnProperty('href')) {
      const normalizedURL = new URL(node.href)
      const isInternal = normalizedURL.hostname === window.location.hostname
      const customer = getCustomer()
      const url = isInternal
        ? addQueryParams(node.href, { overlay: 0, customer })
        : addQueryParams(node.href, { overlay: 0 })

      if (!node.href.includes('overlay=0')) {
        node.setAttribute('href', url)
      }

      node.setAttribute('target', '_blank')
      // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
      node.setAttribute('rel', 'noopener noreferrer')
    }
    // set non-HTML/MathML links to xlink:show=new
    if (
      !node.hasAttribute('target') &&
      (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
    ) {
      node.setAttribute('xlink:show', 'new')
    }
  })
  // cleans HTML
  const html = DOMPurify.sanitize(parseHtml(props.message))

  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

export default DisplayExternalHTML
